import Dialog from 'rc-dialog'
import Drawer from 'rc-drawer'
import React, { FC } from 'react'
import { useStoreActions, useStoreState } from 'store'

interface Props {
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
}

const termsContent = [
  {
    header: '8-year cost',
    content:
      "8-year cost shows the estimated amount you'll have paid in upfront costs (including origination fees and discount points) and interest at the different points in time for each mortgage loan term you've selected.",
  },
  {
    header: 'APR',
    content:
      'APR takes the interest rate of the loan and adds it to certain fees paid by the borrower at closing, including the upfront cost Bankrare displays on each offer. APR shows which loan is less expensive over the full term of the loan.',
  },
  {
    header: 'Monthly (Mo.) payment',
    content:
      'The monthly payment shown includes both principal and interest payment. It does not include your private mortgage insurance (PMI), which your lender may require if your down payment is less than 20 percent of your purchase price.',
  },
  {
    header: 'Points',
    content:
      'Points are fees paid directly to the lender in exhange for a reduced interest rate. A point is equal to one percent of the borrowed funds. By paying more in points upfront, you save money on interest over the life of your loan.',
  },
  {
    header: 'Rate',
    content: "The amount you'll pay each year to borrow the money, expressed as a percentage.",
  },
  {
    header: 'Upfront costs',
    content:
      'The upfront costs shown are charged by the lender for originating the loan. These fees are commonly labeled as Origination, Application, Processing, Underwriting, or Administrative fees on the Loan Estimate.',
  },
]

const TermsExplainedModal: FC<Props> = ({ visible, setVisible }) => {
  const { onClickTracking } = useStoreActions(actions => actions.tracking)
  const isMobilePhoneDevice = useStoreState(state => state.dimensions.isMobilePhoneDevice)

  if (visible) {
    document.getElementsByTagName('html')[0].style.overflow = 'hidden'
    document.getElementsByTagName('body')[0].style.overflow = ''
  } else {
    document.getElementsByTagName('html')[0].style.overflow = ''
  }

  const onModalClose = () => {
    setVisible(false)
    onClickTracking({
      element: {
        type: 'button',
        location: 'modal',
        position: 'top',
        text: 'x',
        name: 'terms explained "x"',
      },
      outcome: 'MODAL',
    })
  }

  const CloseButton = () => (
    <button
      onClick={onModalClose}
      type="button"
      className="terms-explained-modal-drawer__close bg-white p-0 display-flex"
      aria-label="Close modal"
    >
      <svg width="24" height="24" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
        <title>Close icon</title>
        <path
          d="M15.577.808l1.23 1.23-6.77 6.77 6.77 6.769-1.23 1.23-6.77-6.77-6.769 6.77-1.23-1.23 6.769-6.77-6.77-6.769L2.039.808l6.77 6.77 6.769-6.77z"
          fill="#151515"
          fillRule="evenodd"
        />
      </svg>
    </button>
  )

  const modalContent = (
    <div>
      <div className="terms-explained-modal-drawer__header display-flex justify-content-space-between align-items-center bg-white p-4 md:p-6">
        <div className="terms-explained-modal-drawer__title font-circular-bold">Terms explained</div>
        <CloseButton />
      </div>
      <ul className="List type-body-one leading-7 m-0 mt-6 text-slate pb-4 px-4 md:px-6">
        {termsContent.map(term => {
          return (
            <li key={term.header}>
              <p className="m-0">
                <strong className="font-circular-bold">{term.header}</strong>
              </p>
              <p className="m-0">{term.content}</p>
            </li>
          )
        })}
      </ul>
    </div>
  )

  return isMobilePhoneDevice ? (
    <Drawer
      level={null}
      open={visible}
      onClose={onModalClose}
      wrapperClassName={'center'}
      placement="bottom"
      height="75%"
      className="terms-explained-modal-drawer"
    >
      {modalContent}
    </Drawer>
  ) : (
    <Dialog
      visible={visible}
      onClose={onModalClose}
      wrapClassName={'center'}
      focusTriggerAfterClose={false}
      className="terms-explained-modal-drawer"
    >
      {modalContent}
    </Dialog>
  )
}

export default TermsExplainedModal
